<template>
  <v-avatar
    :size="size"
    :color="color"
    tile
    class="account-avatar"
  >
    <span
      class="white--text font-weight-bold text-body-2 account-avatar__initials"
    >{{ initials }}</span>
  </v-avatar>
</template>

<script>
export default {
  name: 'AccountAvatar',
  props: {
    name: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 40
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    initials () {
      const words = (this.name || '')
        .split(/[^a-zA-Z0-9]+/)
        .filter(word => !!word)
      if (!words.length) {
        return '?'
      }
      if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase()
      }
      return (words[0][0] + words[1][0]).toUpperCase()
    }
  }
}
</script>

<style scoped>
.account-avatar {
  border-radius: 6px !important;
}
</style>
